import {mapActions, mapGetters} from 'vuex'

let feedbackMixin = {
	computed: {
		...mapGetters({
			errors: 'get_errors',
			token: 'get_token',
			overlay: 'get_overlay',
			username: 'get_username',
			parentOrganization: 'get_parent_organization',
			accessPrivileges: 'get_access_privileges',
			lastSearchCriteria: 'get_last_search',
			isDataEntryUser: 'get_is_data_entry_user'
		})
	},
	methods: {
		...mapActions({
			pushError: 'push_error',
			clearErrors: 'clear_errors',
			logIn: 'login',
			logOut: 'logout',
			setLastSearch: 'set_last_search',
			setOverlay: 'set_overlay'
		}),
		hasError: function () {
			return this.getErrors.length > 0
		},
		authCheck: function (reason) {
			console.log("Auth check...")
			console.log(JSON.stringify(reason))
			if (reason.response) {
				let that = this
				let msg = reason.response.data.title ? reason.response.data.title : reason.response.statusText
				if (reason.response.status === 401) {
					this.logOut()
						.then(value => {
							that.$router.push('/', function () {
								console.log('User must re-login')
								let msg = msg ? msg : 'Unauthorized'
								that.pushError({
									'type': 'WARNING',
									'message': msg
								})
							})
						})
						.catch(error => {
							console.log('Error on logout')
							console.log(JSON.stringify(error))
						})
				} /*else if (reason.response && reason.response.status === 404) {
					this.$router.replace('/not-found')
				} */ else if (msg) {
					this.pushError({
						'type': 'DANGER',
						'message': msg
					})
				} else {
					console.log('Unknown error')
				}
			} else {
				console.log('Unknown error')
			}
		},
		getValueList: function (valueListName, layoutEntity, primaryKey = null) {
			return this.axios.get('/3ds/api/get-value-list',
				{
					params: {
						valueListName: valueListName,
						layoutEntity: layoutEntity,
						primaryKey: primaryKey
					},
					headers: {
						'Authorization': 'Bearer ' + this.token
					}
				}
			)
		}
	}
}

export default feedbackMixin